import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';
import { ConstanteEcorec } from '../../recylog/application/constante.ecorec';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-panneau-logo',
  templateUrl: './panneau-logo.component.html',
  styleUrls: ['./panneau-logo.component.css']
})
export class PanneauLogoComponent implements OnInit {
  public objet: any = {}; // l'objet principal
  public rowSelect: any = {};
  fileToAdd: any = {};
  objFileObject: any = {};
  cheminLogo: any = '';
  public loadingIndicator: Boolean = false;
  error = '';
  
  @Output() public callback: EventEmitter<any> = new EventEmitter<any>();
  @Input() public titre: string;
  @Input() public table: string;
  @Input() public colonne: string;
  @Input() public colonneClef: string;
  @Input() public postSave: Boolean = false; // Pour savoir si on fait l'enregistrement tout de suite ou avec l'enregistrement de l'objet principal

  @Input()
  set setObjet(val: any) {
    this.objet = val;
    this.getLogo();
  }
  
  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) {

  }

  ngOnInit() {
      if(!this.titre) {
          this.titre = 'Logo';
      }
  }

  showInput(index?) {
    const ctrl = this;
  }

  annuler() {
    this.common.closeModal();
  }

  save() {
    const ctrl = this;
    if(this.postSave) {
       this.callback.emit(this.objFileObject);
    } else {
       this.saveLogo();
    }
    
    this.common.closeModal();
  }

  getNameFile(event, item) {
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImg(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);    
      return;
    }    
    
    item.nomFichier = file.name;
    item.type = file.type;
    item.taille = file.size;
    item['nomclass'] = 'FileObject';

    const fileReader = new FileReader();
    const ctrl = this;
    
    fileReader.onload = function () {
      const result = fileReader.result;
      if (typeof result === 'string') {
        const base64 = result.split(',');
        item.contentBase64 = base64[1];
        ctrl.cheminLogo = result;
        ctrl.objFileObject = item;
      }
    };

    fileReader.readAsDataURL(file);
  }

  getLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': this.table, // 'article',
        'COLONNE': this.colonne, // 'nomFichierLogo',
        'COLONNE_CLEF': this.colonneClef, // 'clefArticle',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.objet.id
        },
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.cheminLogo = datas.data.NOM_FICHIER && datas.data.NOM_FICHIER !== '' ? this.common.intercept(datas.data.NOM_FICHIER) : '';
      }
    });
  }

  saveLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': this.table, // 'article',
        'COLONNE': this.colonne, // 'nomFichierLogo',
        'COLONNE_CLEF': this.colonneClef, // 'clefArticle',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.objet.id
        },
        'FICHIER': this.objFileObject,
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
      }
    });
  }

  /*
  deleteLogo() {
    const ctrl = this;
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': 'article',
        'COLONNE': 'nomFichierLogo',
        'COLONNE_CLEF': 'clefArticle',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.objet.id
        },
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        ctrl.cheminLogo = "";
      }
    });
  }
  */
}
